import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            游戏分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            八大游戏分类，总有一款适合你，点击探索你的游戏世界
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center transition-all duration-300 hover:border-primary-300 hover:bg-primary-50/50 cursor-pointer no-underline"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 mb-2 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.gameCount}款游戏
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}